import { createFileRoute } from "@tanstack/react-router";
import { useEffect } from "react";
import { useRouter } from "@/lib/navigation";

const DEFAULT_TAX_YEAR = String(new Date().getFullYear() - 1);

function RouteComponent() {
  const router = useRouter();
  useEffect(() => {
    router.replace(`/taxes/discrepancies/${DEFAULT_TAX_YEAR}`);
  }, [router]);
  return <div />;
}

export const Route = createFileRoute("/_authenticated/taxes/discrepancies/")({
  component: RouteComponent,
  staticData: { page: "tax" },
});
